import { render, staticRenderFns } from "./news6.vue?vue&type=template&id=3af53fd6&"
import script from "./news6.vue?vue&type=script&lang=js&"
export * from "./news6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports